import React from "react";
import { FiArrowUpRight, FiBookOpen, FiCreditCard, FiMessageCircle, FiUserCheck } from "react-icons/fi";
import { Link } from "react-router-dom";
import { coursesEnabled } from "../../config/courseFeatures";
import CourseSupportExplainer from "./CourseSupportExplainer";
import "./CourseVisuals.css";

export default function CourseSupportCard({ messagesOnly = false, compact = false, dashboard = false, onNavigate }) {
  if (!coursesEnabled || compact || messagesOnly) return null;
  return <section aria-label="Ongoing support" className={`course-feature ${dashboard ? "course-feature-dashboard" : ""}`}>
    <div className="course-feature-top">
      <span className="course-feature-icon"><FiBookOpen aria-hidden="true" /></span>
      <div className="course-feature-meta-group">
        <span className="course-feature-label">Ongoing Class, Course, Exam or Program Support</span>
        <span className="course-feature-new">NEW!</span>
      </div>
      <CourseSupportExplainer className="course-feature-info" />
    </div>
    <div className="course-feature-intro">
      <div className="course-feature-copy">
        <h2>Get expert help with your exam or entire course. 100% human or your money back!</h2>
        <p>Manage a course, class, dissertation, exam preparation, or long-term project without placing a separate order every time.</p>
        <ul className="course-feature-benefits" aria-label="Ongoing support benefits">
          <li><FiUserCheck aria-hidden="true" /> Same writer throughout</li>
          <li><FiCreditCard aria-hidden="true" /> Flexible grouped payments</li>
          <li><FiMessageCircle aria-hidden="true" /> One continuous conversation</li>
        </ul>
      </div>
      <div className="course-feature-actions">
        <Link className="course-feature-cta" to="/courses/new" onClick={onNavigate}>Get a Free Quote <FiArrowUpRight aria-hidden="true" /></Link>
        <Link className="course-feature-secondary" to="/courses" onClick={onNavigate}>View my courses & projects</Link>
      </div>
    </div>
  </section>;
}
